import React, {useState, useEffect, useCallback, useRef, useMemo} from "react"
// Internal Dependancy
import ComponentWrapper from "components/HOC/ComponentWrapper"
import {get, post, put} from "helpers/api"
import styled from "styled-components"
import {Button} from "@uprise/button"
import {text} from "@uprise/typography"
import {Card} from "@uprise/card"
import {spacing} from "@uprise/spacing"
import {Modal} from "@uprise/modal"
import {H4} from "@uprise/headings"
import RoleTable from "./RoleTable"
import toast, {Toaster} from "react-hot-toast"
import {useHistory} from "react-router-dom"
import {ColumnContainer, ColumnText} from "shared/Table/index.style"
import {useAuth0} from "@auth0/auth0-react"

export const HeaderTableContent = styled.div`
	display: flex;
`

export const CustomButton = styled(Button)`
	margin: 5px;
`

const ActionButtonContainer = styled.div`
	display: flex;
	gap: 10px;
	justify-content: center;
	align-items: center;
`
const DeleteConfirmationButtonContainer = styled.div`
	display: flex;
	gap: 10px;
	justify-content: flex-end;
	align-items: center;
	margin-top: 20px;
`

const UpdateButton = styled(Button)`
	width: 100%;
	max-width: 60px;
	height: 32px;
	font-family: "Proxima Nova";
	font-size: ${text.t4};
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.38;
	letter-spacing: normal;
	text-align: center;
	color: #f6f4fc;
`

const AssignButton = styled(Button)`
	width: 100%;
	max-width: 60px;
	height: 32px;
	font-family: "Proxima Nova";
	font-size: ${text.t4};
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.38;
	letter-spacing: normal;
	text-align: center;
	color: #f6f4fc;
	background-color: #409c29;
`

const DeleteButton = styled(Button)`
	width: 100%;
	max-width: 60px;
	height: 32px;
	font-family: "Proxima Nova";
	font-size: ${text.t4};
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.38;
	letter-spacing: normal;
	text-align: center;
	color: #f6f4fc;
	background-color: #d9534f;
	border-color: #d9534f;
`

export const ModalButtonContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`

const Roles = ({}) => {
	const history = useHistory()
	const [allRoles, setAllRoles] = useState([])
	const [allUsers, setAllUsers] = useState([])
	const [deleteModalOpen, setDeleteModalOpen] = useState(false)
	const [selectedRole, setSelectedRole] = useState(null)
	const {getAccessTokenSilently} = useAuth0()

	const getAllRoles = async () => {
		const roles = await get("admin/role/getAllRoles")
		if (roles?.data?.length > 0) {
			const data = roles.data
			setAllRoles(Object.keys(data).map(item => ({roleName: data[item].roleName, id: data[item].id})))
		}
	}

	const getAllUsers = async () => {
		const token = await getAccessTokenSilently()
		let response = await get(`v2/coaches?disabled=0`, {}, {Authorization: `Bearer ${token}`})
		if (response?.success) {
			const data = response.data
			setAllUsers(
				Object.keys(data).map(item => ({
					name: data[item].name,
					id: data[item].id,
					email: data[item].email,
					roleId: data[item].roleId
				}))
			)
		}
	}

	useEffect(() => {
		getAllRoles()
		getAllUsers()
	}, [])

	const ActionComponent = ({id, row}) => {
		console.log(row)
		return (
			<ActionButtonContainer>
				<AssignButton
					title={"Assign"}
					variant={"primary"}
					onClick={() =>
						history.push({
							pathname: "/roles/assign"
						})
					}
					data-testid='assignButtom'
					hover={false}
				/>
				<UpdateButton
					title={"Edit"}
					variant={"primary"}
					onClick={() =>
						history.push({
							pathname: "/roles/edit",
							state: {
								roleId: id
							}
						})
					}
					data-testid='updateButton'
					hover={false}
				/>
				<DeleteButton
					title={"Delete"}
					variant={"primary"}
					onClick={() => {
						setDeleteModalOpen(true)
						setSelectedRole(id)
					}}
					data-testid='deleteButton'
					disabled={row?.roleName === "__DEFAULT__"}
					hover={false}
				/>
			</ActionButtonContainer>
		)
	}
	const columns = useMemo(
		() => [
			// { Header: "id", accessor: "id", show: false },
			{
				Header: "Role name",
				accessor: "roleName",
				disableSortBy: true,
				show: true,
				Cell: cellInfo => {
					return (
						<ColumnContainer
							alignText='center'
							onClick={() => {
								history.push(`/roles/${cellInfo.row.original.id}`, {
									roleName: cellInfo.row.original.roleName
								})
							}}>
							<ColumnText link={true} id={cellInfo.row.original.id} row={cellInfo.row.original}>
								{cellInfo.row.original.roleName}
							</ColumnText>
						</ColumnContainer>
					)
				}
			},
			{
				Header: "Action",
				disableSortBy: true,
				// accessor: "",
				Cell: cellInfo => <ActionComponent id={cellInfo.row.original.id} row={cellInfo.row.original} />,
				show: true
			}
		],
		[]
	)

	const onDeleteRoleConfirm = () => {
		console.log(selectedRole)
		if (selectedRole) {
			post("role/deleteRole", {
				roleId: parseInt(selectedRole)
			})
				.then(result => {
					console.log(result)
					toast("Role deleted successfully")
					setDeleteModalOpen(false)
					getAllRoles()
				})
				.catch(error => {
					console.log(error)
					toast.error("Error while deleting role")
				})
		}
	}

	const updateUserRole = async (userId, roleId) => {
		try {
			const token = await getAccessTokenSilently()
			let response = await put(
				`admin/role/assignRoleToUser`,
				{userId, roleId},
				{Authorization: `Bearer ${token}`}
			)
			console.log(response)
			if (response) {
				getAllUsers()
				// getAllRoles()
			}
		} catch (error) {
			console.log(error)
		}
	}


	const isDataLoaded = allRoles?.length > 0 && allUsers?.length > 0
	return (
		<ComponentWrapper
			menuActiveIndex={17}
			subMenuActiveIndex={17}
			headerTitle='User Roles'
			headerRightAlignContent={<></>}>
			<Card padding={spacing.s10} backgroundColor='white'>
				{isDataLoaded && (
					<div style={{flexDirection: "row", display: "flex"}}>
						<div style={{width: 200, fontWeight: "bold"}}>User name</div>
						<div style={{width: 200, fontWeight: "bold"}}>Email</div>
						{allRoles?.map((item, _) => {
							return (
								<div
									style={{
										width: 120,
										display: "flex",
										justifyContent: "center",
										fontWeight: "bold",
										overflowWrap: "break-word"
									}}
									key={item.id}>
									{item?.roleName}
								</div>
							)
						})}
					</div>
				)}
				<div style={{height: 1, width: "100%", backgroundColor: "#7c60ff", marginTop: 20}}></div>
				{isDataLoaded &&
					allUsers?.map((userItem, _) => {
						return (
							<div
								key={userItem.id}
								style={{
									flexDirection: "row",
									display: "flex",
									marginTop: 20,
									paddingBottom: 20,
									borderBottomWidth: 0.7,
									borderBottomColor: "#eceafa",
									borderBottomStyle: "solid"
								}}>
								<div style={{width: 200, overflowWrap: "break-word"}}>{userItem.name}</div>
								<div style={{width: 200, overflowWrap: "break-word"}}>{userItem.email}</div>
								{allRoles?.map((roleItem, _) => {
									return (
										<div
											key={roleItem.id}
											style={{
												width: 120,
												display: "flex",
												justifyContent: "center",
												fontWeight: "bold",
												overflowWrap: "break-word"
											}}>
											<input
												type='radio'
												value={roleItem.id}
												checked={userItem.roleId == roleItem.id ? true : false}
												style={{accentColor: "#7c60ff"}}
												onChange={e => updateUserRole(userItem.id, roleItem.id)}
											/>
										</div>
									)
								})}
							</div>
						)
					})}
			</Card>

			<Toaster />
		</ComponentWrapper>
	)
}

export default Roles
